module.exports = __webpack_public_path__ + "static/media/text-message-icon.606b8b3b.png";